var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneCall = function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.925 5A10.012 10.012 0 0 1 27 12.075m-8.112-3.212a5.988 5.988 0 0 1 4.25 4.25M11.563 15.6a10.45 10.45 0 0 0 4.874 4.862 1 1 0 0 0 .988-.075L20.55 18.3a.988.988 0 0 1 .95-.088l5.85 2.513a.987.987 0 0 1 .6 1.037A6 6 0 0 1 22 27 17 17 0 0 1 5 10a6 6 0 0 1 5.238-5.95.988.988 0 0 1 1.037.6l2.512 5.862a1 1 0 0 1-.075.938l-2.087 3.175a1 1 0 0 0-.063.975v0Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhoneCall;